/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;padding:100px;font-family:\"Gotham A\",\"Gotham B\",\"Helvetica Neue\",Helvetica,Arial,sans-serif!important;font-style:normal!important;font-weight:700!important;font-size:25px;text-align:center}"];
export { styles as styles };
